<template>
	<v-dialog
		v-model="showDialog"
		max-width="700px"
		height="90%"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-if="requiredDialogBtn" v-slot:activator="{ on, attrs }">
			<slot name="open-btn" :openDialog="openDialog">
				<v-btn
					:text="text"
					:color="text ? 'white' : 'secondary'"
					class="ml-2"
					@click.stop="openDialog"
					v-bind="attrs"
					v-on="on"
				>
					<v-icon class="mr-1">mdi-file-document</v-icon>
					ゴム加工情報
				</v-btn>
			</slot>
		</template>

		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">ゴム加工情報</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-sheet elevation="0" class="pa-2">
				<RubberProcessInfoUnit
					v-if="rubberProcess && rubberProcess != {}"
					:rubber_process="rubberProcess"
					:teams="teams"
					:allowSelectTeam="allowSelectTeam"
					@update-rubber-process="updateRubberProcess($event)"
				/>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import Loading from "../../shared/IndeterminateLoadingView.vue"
import RubberProcessInfoUnit from "./RubberProcessInfoUnit.vue"

export default {
	props: {
		text: Boolean,
		requiredDialogBtn: {
			type: Boolean,
			required: false,
			default: false,
		},
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		id: {
			type: null,
			required: false,
		},
		is_draft: {
			type: Boolean,
			required: false,
			default: false,
		},
		showEditBtn: {
			type: Boolean,
			required: false,
			default: false,
		},
		teams: {
			type: Array,
			required: false,
			default: () => [],
		},
		allowSelectTeam: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	components: {
		Loading,
		RubberProcessInfoUnit,
	},
	data() {
		return {
			authorityFlag: false,
			loading: false,
			dataDialog: false,
			rubberProcess: null,
		}
	},
	methods: {
		openDialog() {
			if (!this.rubberProcess || this.rubberProcess.id != this.id) {
				this.fetchRubberProcess(this.id)
			} else {
				this.showDialog = true
			}
		},
		fetchRubberProcess(id) {
			this.loading = true
			const headers = authenticate.setHeader()
			const url = `/erp/v1/rubber_processes/${id}`
			axios
				.get(url, { headers, params: { is_draft: this.is_draft } })
				.then((res) => {
					this.showDialog = true
					this.rubberProcess = res.data.rubber_process
					this.authorityFlag = res.data.authority_flag
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
				.finally(() => this.$nextTick(() => (this.loading = false)))
		},
		updateRubberProcess(rubberProcess) {
			this.rubberProcess = rubberProcess
			this.$emit("update-rubber-process", rubberProcess)
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog ? this.dialog : this.dataDialog
			},
			set(newVal) {
				return this.dialog ? this.$emit("update:dialog", newVal) : (this.dataDialog = newVal)
			},
		},
		isFetched() {
			return (name) => {
				const tab = this.tabs.find((t) => t.name == name)
				return tab != null ? tab.isFetched : false
			}
		},
	},
	watch: {
		rubber_process(newVal, _) {
			this.rubberProcess = newVal
		},
		id(newVal, oldVal) {
			if (newVal == oldVal) return
			this.fetchRubberProcess(newVal)
		},
		deep: true,
	},
}
</script>

<style lang="scss" scoped>
.products {
	.row {
		&:not(:first-child) {
			border-top: 1px solid whitesmoke;
		}
	}
}
.theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
	color: black;
}
</style>
